/**
 * Object manipulation utilities
 */

export const flattenObject = (obj, parentKey = 'user', result = {}) => {
  Object.entries(obj).forEach(([key, value]) => {
    const newKey = `${parentKey}_${key}`

    if (Array.isArray(value)) {
      // flatten arrays with index
      value.forEach((item, index) => {
        if (typeof item === 'object' && item !== null) {
          flattenObject(item, `${newKey}_${index}`, result)
        } else {
          result[`${newKey}_${index}`] = item
        }
      })
    } else if (typeof value === 'object' && value !== null) {
      // recurse for nested objects
      flattenObject(value, newKey, result)
    } else {
      result[newKey] = value
    }
  })
  return result
}
